module.exports = __webpack_public_path__ + "static/media/img1-1.2d245282.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/nutricheck_foliar/CA/img1-1.png
// module id = 1562
// module chunks = 3